import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const VideoModal = ({ open, src, title, onClose }) => {
  return (
    <AnimatePresence>
      {open && src && (
        <motion.div
          data-testid="video-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[800] flex flex-col"
          style={{ background: "#000" }}
        >
          <div className="flex items-center justify-between px-4 py-3">
            <span className="font-serif-display text-lg truncate pr-3" style={{ color: "#f3f4f6" }}>
              {title || "Presentación"}
            </span>
            <button
              data-testid="video-modal-close"
              onClick={onClose}
              className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(212,175,55,0.3)" }}
            >
              <X size={20} style={{ color: "#f3f4f6" }} />
            </button>
          </div>
          <div className="flex-1 flex items-center justify-center px-2 pb-4">
            <video
              data-testid="video-modal-player"
              controls
              autoPlay
              playsInline
              onEnded={onClose}
              className="w-full max-h-full rounded-xl"
              style={{ background: "#000" }}
              src={src}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
